var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgRecents = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 17,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8 .35c-4.411 0-8 3.588-8 8 0 4.41 3.589 8 8 8s8-3.59 8-8c0-4.412-3.589-8-8-8Zm2.634 11.765L7.2 8.681V3.55h1.6v4.468l2.966 2.966-1.132 1.131Z",
  fill: "#98A4AF"
})));
export { SvgRecents as ReactComponent };
export default __webpack_public_path__ + "3596882596bb3178bf95dcf46cdfdb1f.svg";